import { render, staticRenderFns } from "./LatestNewsView.vue?vue&type=template&id=6f60e0cf"
import script from "./LatestNewsView.vue?vue&type=script&lang=ts"
export * from "./LatestNewsView.vue?vue&type=script&lang=ts"
import style0 from "./LatestNewsView.vue?vue&type=style&index=0&id=6f60e0cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports